import React, { FC } from 'react'
import { motion } from 'framer-motion'
import AnniversaryTicker from 'src/components/ui/AnniversaryTicker'
import HeaderSearch from 'src/components/layout/HeaderSearch'
import DesktopLogo from './DesktopLogo'
import DesktopActions from './DesktopActions'
import { IDesktopHeaderProps } from './types'

export const DesktopHeader: FC<IDesktopHeaderProps> = ({
  showAnniversaryTicker = true,
  showSearch = false,
  searchValue,
  onSearchChange,
  searchPlaceholder,
  searchSlot,
  shouldAnimate = false,
  shouldShowIso = true,
  isDesignSystem = false,
  actionText,
  actionUrl,
  onActionClick,
  actionSlot,
  actionIcon,
  isActionOutline = false,
}) => {
  return (
    <motion.div
      id="header-container"
      initial={shouldAnimate ? { y: -50, opacity: 0 } : false}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut', delay: 0.1 }}
      className={`hidden md:block bg-transparent absolute top-0 left-0 right-0 z-20 pointer-events-auto ${shouldAnimate ? 'opacity-0' : 'opacity-100'}`}
    >
      {showAnniversaryTicker && <AnniversaryTicker />}
      <header
        id="header"
        className={`flex justify-between items-center container ${showAnniversaryTicker ? 'py-8' : 'py-12'} relative z-10 pointer-events-auto`}
      >
        <DesktopLogo />

        {showSearch && (
          searchSlot ? (
            searchSlot
          ) : (
            <HeaderSearch
              value={searchValue}
              onChange={onSearchChange}
              placeholder={searchPlaceholder}
              variant="desktop"
            />
          )
        )}

        <DesktopActions
          shouldShowIso={shouldShowIso}
          isDesignSystem={isDesignSystem}
          actionText={actionText}
          actionUrl={actionUrl}
          onActionClick={onActionClick}
          actionSlot={actionSlot}
          actionIcon={actionIcon}
          isActionOutline={isActionOutline}
        />
      </header>
    </motion.div>
  )
}

export default DesktopHeader
